export enum RoomCardVariants {
  Default = 'default',
  BestDeal = 'bestDeal',
  SelectedDeal = 'selectedDeal',
  YourFrozenDeal = 'yourFrozenDeal',
  SplitBookingCheapest = 'sbCheapest',
  None = 'none'
}
